var myMixin = {
    data() {
      return {
        isSearch: false
      };
    },
   
    methods: {
        isSearch1(){
            console.log(111)
            this.isSearch = !this.isSearch
        }
   
    },
  };
  
  export default myMixin;